import { Component, HostListener, OnInit, OnDestroy } from '@angular/core';
import { UserService } from 'src/app/core/services/user.service';
import { AlertService } from 'src/app/modules/case-new-view/alert.service';
import { Event, NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import {
  INotification,
  NotificacionService,
} from 'src/app/services/notificaciones.service';
import { SocketService } from 'src/app/core/services/socket.service';
import { MatDialog } from '@angular/material/dialog';
import { AcceptAlertComponent } from 'src/app/modules/cases/components/alert-content/accept-alert/accept-alert.component';
import { TimerService } from 'src/app/services/timer.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { tr } from 'date-fns/locale';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription = new Subscription();
  isModalOpen: boolean = false;
  isProcessModalOpen: boolean = false;
  alert: any = null;

  constructor(
    public userService: UserService,
    public alertService: AlertService,
    private router: Router,
    private _notification: NotificacionService,
    private socket: SocketService,
    private dialog: MatDialog,
    private timerService: TimerService,
    private _snackBar: MatSnackBar
  ) {}

  notificaciones: INotification[] = [];
  showGoBack: boolean = false;
  viewNotifications: boolean = false;
  text: string = '';
  countNotifications = 0;
  showTimer: boolean = false;
  doCaseTimer;

  // El menú de usuario es mat-menu (cierra solo); esto cubre la campana.
  @HostListener('document:keydown.escape')
  onEscape() {
    this.viewNotifications = false;
  }

  // Click fuera de la campana / panel de notificaciones → cerrar al primer click.
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (
      this.viewNotifications &&
      target?.closest &&
      !target.closest('.notificaciones, .notification-button')
    ) {
      this.viewNotifications = false;
    }
  }

  doLogout() {
    this.userService.doLogout();
  }

  getNotifications() {
    this._notification.countNotificationsUnread().subscribe((count) => {
      this.countNotifications = count;
    });
  }

  ngOnInit() {
    this.getNotifications();
    // Suscripción al evento de socket 'timer_update_doCase'
    // this.socket.socket.on('timer_update_doCase', (data) => {
    //   if (data.idAnalista == this.userService.currentUser?._id) {
    //     this.updateTimerDisplay(data.doCaseTimer);
    //     this.showTimer = true;
    //   }
    // });

    // Suscripción al evento de socket 'timer_finish_doCase'
    this.socket.socket.on('timer_finish_doCase', (data) => {
      if (data.idAnalista == this.userService.currentUser?._id) {
        this.updateTimerDisplay(data.doCaseTimer);
        this.showTimer = false;
        this._snackBar.open('Tiempo finalizado, alerta rechazada', '', {
          duration: 3000,
          horizontalPosition: 'center',
          verticalPosition: 'bottom',
        });
      }
    });

    this.socket.socket.on('open_modal_accept_alert', (data) => {
      if (
        data.idAnalista.toString() ==
        this.userService.currentUser?._id.toString()
      ) {
        // this.openModal();
        this.isModalOpen = true;

        this.alertService.alertInProcess = data.alert;
        this.alert = data.alert;
      }
    });

    // Suscripción al alertProcesFinished
    const alertProcessFinishedSubscription =
      this.alertService.alertProcesFinished.subscribe({
        next: (is: any) => {
          if (is._id == this.userService.currentUser?._id) {
            this.showTimer = false;

            this._snackBar.open('Alerta finalizada', '', {
              duration: 3000,
              horizontalPosition: 'center',
              verticalPosition: 'bottom',
            });
          }
        },
      });

    // Suscripción a toHeaderInfo del alertService
    const alertServiceSubscription = this.alertService.toHeaderInfo.subscribe({
      next: (data) => {
        if (data.information) this.text = data.information;
      },
    });

    // Suscripción a toHeaderInfo del timerService
    const timerServiceSubscription = this.timerService.toHeaderInfo.subscribe({
      next: (data) => {
        if (data.information) this.text = data.information;
      },
    });

    // Suscripción a eventos de navegación
    const routerSubscription = this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        this.viewNotifications = false;
        if (
          event.url.split('/')[1] !== 'casesnew' &&
          event.url.split('/')[1] !== 'strike-user'
        ) {
          this.text = '';
          this.showGoBack = false;
        } else {
          this.showGoBack = true;
        }
      }
    });

    // Suscripción a notificaciones
    const notificationSubscription = this._notification.updateUnreads.subscribe(
      {
        next: () => {
          this.getNotifications();
        },
      }
    );

    // Agregar todas las suscripciones al objeto Subscription
    this.subscriptions.add(alertProcessFinishedSubscription);
    this.subscriptions.add(alertServiceSubscription);
    this.subscriptions.add(timerServiceSubscription);
    this.subscriptions.add(routerSubscription);
    this.subscriptions.add(notificationSubscription);
  }

  ngOnDestroy() {
    // Desuscribirse de todas las suscripciones
    this.subscriptions.unsubscribe();
    this.socket.socket.off('open_modal_accept_alert');
    this.socket.socket.off('timer_update_doCase');
    this.socket.socket.off('timer_finish_doCase');
  }

  // Convierte los segundos en formato hh:mm:ss
  updateTimerDisplay(seconds: number) {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;

    this.doCaseTimer = `${this.pad(hours)}:${this.pad(minutes)}:${this.pad(
      secs
    )}`;
  }

  // Agrega un cero a la izquierda si el número es menor a 10
  pad(num: number): string {
    return num < 10 ? `0${num}` : `${num}`;
  }

  public back() {
    window.history.go(-1);
  }

  get name() {
    return this.userService.currentUser?.fullname;
  }
  get roeleName() {
    return this.userService.currentUser?.role.name;
  }
  get photo() {
    return this.userService.currentUser?.photo
      ? this.userService.currentUser?.photo
      : 'assets/images/user.png';
  }

  onAlertModalClose() {
    this.isModalOpen = false;
  }

  onOpenProcessModal() {
    this.isModalOpen = false;
    this.isProcessModalOpen = true;
  }
}
